import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { countOfRecourd, dateToJalali, getRelation } from '../../Utils/Helpers';
import Pagination from '../Pagination/Pagination';

const Datatable = ({
  data,
  columns = [],
  rows = [],
  meta,
  setModalRemoveObject,
  setModalIsOpen,
  search,
  editUrl,
  editParametr = false,
  editQueryParameters = false,
  disabledEditRemoveIf = () => {},
  disableAllActions = false,
  basePagePath = '/',
  selectRows = false,
  setRowId,
  rowId,
  checkedField = 'id',
  showCountRecourd = true,
}) => {
  const generateLink = (link, params, dataRow) => {
    let fullLink = link;
    for (let param of params) {
      fullLink = fullLink.replaceAll(
        new RegExp(`({([${param}]+)})`, 'g'),
        dataRow[param],
      );
    }
    return fullLink;
  };

  const selectAllRows = (checked) => {
    if (checked) {
      setRowId(data?.map((d) => d?.[checkedField]));
    } else {
      setRowId([]);
    }
  };

  const getRelationsLength = (item, name) => {
    const relName = name.split('.');

    let count = 0;
    for (let i of item?.[relName[0]]) {
      count += i?.[relName[1]]?.length;
    }
    return count;
  };

  return (
    <div className='row'>
      <div className='col-12 overflow-auto'>
        {data?.length > 0 ? (
          <table className='table table-hover table-striped overflow-hidden rounded-1 shadow-sm text-left'>
            <thead className='thead-persian-green text-left'>
              <tr>
                {selectRows && (
                  <th>
                    <div className='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                      <input
                        className='checkbox-flip'
                        type='checkbox'
                        id='check1'
                        onChange={(e) => selectAllRows(e.target.checked)}
                      />
                      <label htmlFor='check1' className='c-pointer'>
                        <span></span>
                      </label>
                    </div>
                  </th>
                )}
                {showCountRecourd && <th>#</th>}

                {columns?.map((item, index) => (
                  <th key={index}>{item}</th>
                ))}
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id}>
                  {selectRows && (
                    <td>
                      <div className='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                        <input
                          className='checkbox-flip'
                          type='checkbox'
                          value={item?.[checkedField]}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setRowId([...rowId, item?.[checkedField]]);
                            } else {
                              const ch = [...rowId];
                              let chFilter = ch.filter(
                                (c) => c != item?.[checkedField],
                              );
                              setRowId(chFilter);
                            }
                          }}
                          checked={rowId?.includes(item?.[checkedField])}
                          id={`check${item?.[checkedField]}`}
                          name={`item_${item?.[checkedField]}`}
                        />
                        <label
                          htmlFor={`check${item?.[checkedField]}`}
                          className='c-pointer'
                        >
                          <span></span>
                        </label>
                      </div>
                    </td>
                  )}

                  {showCountRecourd && (
                    <td>
                      {countOfRecourd(
                        meta?.pagination?.per_page === undefined
                          ? index + 1
                          : index,
                        meta?.pagination?.per_page,
                        meta?.pagination?.current_page,
                      )}
                    </td>
                  )}

                  {rows?.map((row, index2) => (
                    <Fragment key={index2}>
                      {row?.type === 'image' ? (
                        <td>
                          <img
                            src={item[row?.name]}
                            alt=''
                            style={{ width: '50px', height: '50px' }}
                          />
                        </td>
                      ) : row?.type === 'string' ? (
                        <td>{item[row?.name]}</td>
                      ) : row.type === 'date' ? (
                        <td>{dateToJalali(item?.[row?.name])}</td>
                      ) : row.type === 'relation' ? (
                        <td>{getRelation(item, row)}</td>
                      ) : row.type === 'length' ? (
                        <td>{item?.[row?.name]?.length}</td>
                      ) : row.type === 'relLength' ? (
                        <td>{getRelationsLength(item, row?.name)}</td>
                      ) : row?.type === 'relationArray' ? (
                        <td>
                          {item?.[row?.name]
                            ?.map(
                              (r) =>
                                `${r?.[row?.showField]} ${
                                  item?.[row?.name]?.[
                                    item?.[row?.name]?.length - 1
                                  ] != r
                                    ? '-'
                                    : ''
                                } `,
                            )
                            ?.toString()}
                        </td>
                      ) : row?.type === 'action' ? (
                        <td>
                          <span
                            className='text-danger f-13 font-weight-bold c-pointer'
                            onClick={() => row?.action(item)}
                          >
                            {row?.loading?.loading &&
                            row?.loading?.id == item?.id ? (
                              <div
                                className='spinner-border text-white spinner-border-sm mb-1'
                                role='status'
                              >
                                <span className='sr-only'></span>
                              </div>
                            ) : row?.title === undefined ? (
                              'نمایش'
                            ) : (
                              row?.title
                            )}
                          </span>
                        </td>
                      ) : row.type === 'link' ? (
                        <td className='text-center'>
                          {row?.linkType === 'icon' ? (
                            <Link
                              to={generateLink(row?.link, row?.params, item)}
                              className='c-pointer d-flex flex-row'
                            >
                              <i
                                className={`${row?.iconClass} text-dark f-18 c-pointer`}
                              ></i>
                            </Link>
                          ) : row?.linkType === 'text' ? (
                            <Link
                              to={generateLink(row?.link, row?.params, item)}
                              className='text-danger f-12 font-weight-bold c-pointer d-flex flex-row'
                            >
                              {row?.linkTitle}
                            </Link>
                          ) : null}
                        </td>
                      ) : row?.type === 'status' ? (
                        <td>
                          {item[row?.name] === 1 ? (
                            <span className='badge badge-success badge-pill f-13'>
                              فعال
                            </span>
                          ) : (
                            <span className='badge badge-danger badge-pill f-13'>
                              غیرفعال
                            </span>
                          )}
                        </td>
                      ) : row.type === 'confirm' ? (
                        <td>
                          <span
                            className={`badge ${
                              row?.badgeClass[item[row?.name]]
                            } badge-pill f-12`}
                          >
                            {row?.active[item[row?.name]]}
                          </span>
                        </td>
                      ) : row?.type == 'modal' ? (
                        <td>
                          <button
                            onClick={() => {
                              row?.setData(item);
                              row?.setModalIsOpen(true);
                            }}
                            className='btn btn-sm btn-info'
                          >
                            نمایش
                          </button>
                        </td>
                      ) : null}
                    </Fragment>
                  ))}

                  {!disableAllActions && !disabledEditRemoveIf(item) ? (
                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          target='_blank'
                          to={`${editUrl}/${
                            editParametr === false
                              ? item?.id
                              : `${getRelation(item, {
                                  name: editParametr,
                                })}${
                                  editQueryParameters !== false
                                    ? '?' +
                                      editQueryParameters[0] +
                                      '=' +
                                      item[editQueryParameters[1]]
                                    : ''
                                }`
                          }`}
                          className='mx-2'
                        >
                          <i className='fad fa-edit f-16 text-success'></i>
                        </Link>
                        <Link
                          className='mx-2'
                          to='#'
                          onClick={(e) => {
                            e.preventDefault();
                            setModalRemoveObject(item);
                            setModalIsOpen(true);
                          }}
                        >
                          <i className='fad fa-trash f-16 text-danger'></i>
                        </Link>
                      </div>
                    </td>
                  ) : (
                    <td>-</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <span className='f-13 font-weight-bold text-secondary'>
              اطلاعاتی جهت نمایش یافت نشد.
            </span>
          </div>
        )}
      </div>
      {meta?.pagination?.total_pages > 1 && (
        <div className='col-12'>
          <div className='w-100 mt-4 d-flex'>
            <Pagination
              totalPage={meta?.pagination?.total_pages}
              basePath={basePagePath}
              search={search}
            />
          </div>
        </div>
      )}
    </div>
  );
};

Datatable.propType = {
  data: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
  setModalRemoveObject: PropTypes.func.isRequired,
  setModalIsOpen: PropTypes.func.isRequired,
  search: PropTypes.object.isRequired,
  editUrl: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  selectAction: PropTypes.func,
  selectRows: PropTypes.bool,
};

export default Datatable;
